import { defineComponent } from '../utils/create';
export default defineComponent({
  _scopeId: 'data-v-2d00c19e',
  name: 'CbColumn',
  props: {
    column: {
      type: Object,
      default: () => {}
    },
    columnSlots: {
      type: Object,
      default: () => {}
    },
    scopedSlots: {
      type: Object,
      default: () => {}
    },
    row: {
      type: Object,
      default: () => {}
    },
    rowIndex: {
      type: Number,
      default: 0
    },
    cellClassNames: {
      type: String,
      default: ''
    },
    // eslint-disable-next-line vue/require-prop-types
    col: {
      required: true
    }
  },
  methods: {
    getColumnClassNames() {
      return {
        cell: true,
        [this.cellClassNames]: true,
        'no-wrap': this.column.noWrap !== 'wrap' || this.column.noWrap === undefined,
        'align-center': this.column.align === 'center',
        'align-left': this.column.align === 'left',
        'align-right': this.column.align === 'right'
      };
    }
  },
  render() {
    var h = arguments[0];
    var formatter = this.column.formatter;
    var slotName = this.column.slot || this.column.prop;
    var scopeSlot = this.scopedSlots[slotName];
    var txt = this.col;
    if (typeof scopeSlot === 'function') {
      return scopeSlot({
        col: this.col,
        row: this.row,
        index: this.rowIndex
      });
    }
    if (typeof formatter === 'function') {
      txt = formatter(this.col, this.row, this.rowIndex);
    }
    return h("span", {
      "class": this.getColumnClassNames()
    }, [txt]);
  }
});